import React, { PureComponent } from 'react'
import styled from 'styled-components'
export default class Login extends PureComponent {
  render() {
    return (
      <Container>
        
          <CTA>
            <CTALogoOne src='/images/cta-logo-one.svg'/>
            <Signup>GET ALL THERE</Signup>
            <Description>GET ALL THERE</Description>
            <CTALogoTwo src='/images/cta-logo-two.png'/>
          </CTA>
        
      </Container>
    )
  }5
}
const Container=styled.div`

height:calc(100vh - 70px);

display:flex;
align-items: top ;
justify-content: center;
position: relation;

&:before {
  background-position: top;
  background-size:cover;
  background-repeat:no-repeat;
  position: absolute;
  content: "";
  opacity:0.7;
  

  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index:-1;
  background-image:url("/images/login-background.jpg");
}



`
// const Content=styled.div`

// `

const CTA=styled.div`
max-width:650px;
padding: 80px 40px;
width: 90%;
margin-top: 100px;
display:flex;
flex-direction:column;
align-items: center;

`

const CTALogoOne=styled.img`

`
const CTALogoTwo=styled.img`
width: 90%;
`

const Signup=styled.a`
max-width:650px;
padding: 80px 40px;
width: 100%;
background-color: #0063e5;
font-weight: bold;
padding: 17px 0;
color:#f9f9f9;
border-radius:4px;
text-align: center;
font-size:18px;
cursor: pointer;
transition: all 250ms;
letter-spacing: 1.5px;
margin-top:8px;
margin-top:12px;

&:hover{
  background: #0483ee;
  
}
`

const Description = styled.p`
font-size:18px;
letter-spacing: 1.5px;
text-align: center;
line-height: 1.5;
`